import { render, staticRenderFns } from "./MailboxItem.vue?vue&type=template&id=a94fb644&scoped=true&"
import script from "./MailboxItem.vue?vue&type=script&lang=ts&"
export * from "./MailboxItem.vue?vue&type=script&lang=ts&"
import style0 from "./MailboxItem.vue?vue&type=style&index=0&id=a94fb644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94fb644",
  null
  
)

/* custom blocks */
import block0 from "../quotation/quotation-i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc2346394130%2Fsrc%2Ffrontend%2Fcomponents%2Fmailbox%2FMailboxItem.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./MailboxItem.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem})
